import BConfig from "../../modules/BConfig";
import BRequest from "../../modules/BRequest";
import BEnergy from "../Modules/BEnergy";
import BQuantity from "../Modules/BQuantity";

export default class BDiaryNutrientGoalTemplateForm
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.diary-nutrient-goal-template-form`;

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("change", function (event) {
			if (event.target.matches(`${BDiaryNutrientGoalTemplateForm.selector()} [name="programId"]`)) {
				const form = new BDiaryNutrientGoalTemplateForm(event.target.closest(BDiaryNutrientGoalTemplateForm.selector()));
				form.setNutrientsFromProgram();
			}
		});

		document.addEventListener("change", function (event) {
			if (event.target.matches(`${BDiaryNutrientGoalTemplateForm.selector()} input`)) {
				const form = new BDiaryNutrientGoalTemplateForm(event.target.closest(BDiaryNutrientGoalTemplateForm.selector()));
				form.setEnergyFromNutrients();
			}
		});

		document.addEventListener("change", function (event) {
			if (event.target.matches(`${BDiaryNutrientGoalTemplateForm.selector()} [name="isCustom"]`)) {
				const form = new BDiaryNutrientGoalTemplateForm(event.target.closest(BDiaryNutrientGoalTemplateForm.selector()));
				form.setIsCustom(event.target.checked);
			}
		});

		document.addEventListener("change", function (event) {
			if (event.target.matches(`${BDiaryNutrientGoalTemplateForm.selector()} [name="nutrientPracticalUnitId_ENERGY"]`)) {
				const selectElement = event.target;
				const amountElement = document.querySelector(`${BDiaryNutrientGoalTemplateForm.selector()} [name="nutrientAmount_ENERGY"]`);

				const sourceUnit = selectElement.dataset.unitAbbr;
				const targetUnit = selectElement.options[selectElement.selectedIndex].text;

				selectElement.dataset.unitAbbr = targetUnit;

				const amount = parseFloat(amountElement.value.replace(",", "."));
				const energy = new BEnergy(amount, sourceUnit);

				amountElement.value = energy.getQuantity(targetUnit).getAmount().toString().replace(".", ",");
			}
		});
	}

	getNutrientParams()
	{
		return {
			"energy": this.el.querySelector(`[name="nutrientAmount_ENERGY"]`).value,
			"carbs": this.el.querySelector(`[name="nutrientAmount_CARBS"]`).value,
			"fats": this.el.querySelector(`[name="nutrientAmount_FATS"]`).value,
			"proteins": this.el.querySelector(`[name="nutrientAmount_PROTEINS"]`).value,
		};
	}

	getProgramId()
	{
		return parseInt(this.el.querySelector(`[name="programId"]`).value);
	}

	setNutrientsFromProgram()
	{
		const url = BConfig.getRoute("api.v2.diets.getNutrientQuantities")
			.replace("{dietId}", this.getProgramId())
			;

		BRequest.get(url, null, {
			headers: {
				"Accept": "application/json",
			}
		}).then(response => {
			Object.entries(response.data).forEach(([nutrientCode, nutrientQuantity]) => {
				const element = this.el.querySelector(`.diary-nutrient-goal-template-table__nutrient-quantity--${nutrientQuantity.nutrient.code}`);
				if (nutrientQuantity.nutrient.code == "ENERGY") {
					const energy = new BEnergy(nutrientQuantity.quantity.amount, nutrientQuantity.quantity.unit.abbr);
					element.querySelector(`.diary-nutrient-goal-template-table__nutrient-amount--KCAL`).innerHTML = energy.getQuantity("kcal").getReadable();
					element.querySelector(`.diary-nutrient-goal-template-table__nutrient-amount--KJ`).innerHTML = energy.getQuantity("kJ").getReadable();
				} else {
					const quantity = new BQuantity(nutrientQuantity.quantity.amount, nutrientQuantity.quantity.unit.abbr);
					element.querySelector(`.diary-nutrient-goal-template-table__nutrient-amount--G`).innerHTML = quantity.getReadable();
				}
			});
		}).catch(error => {
			console.log(error);
		});
	}

	setEnergyFromNutrients()
	{
		const url = BConfig.getRoute("api.v2.diaryNutrientGoalTemplates.calculate");
		const data = this.getNutrientParams();

		BRequest.get(url, data, {
			headers: {
				"Accept": "application/json",
			}
		}).then(response => {
			const energyUnitElement = this.el.querySelector(`[name="nutrientPracticalUnitId_ENERGY"]`);
			const energyUnit = energyUnitElement.options[energyUnitElement.selectedIndex].text.trim();

			const nutrientQuantities = response.data.nutrientQuantities;
			const energyNutrientQuantity = nutrientQuantities.filter(nutrientQuantity => {
				return nutrientQuantity.nutrient.code == "ENERGY" && nutrientQuantity.quantity.unit.abbr == "J";
			})[0];
			const energy = new BEnergy(energyNutrientQuantity.quantity.amount, energyNutrientQuantity.quantity.unit.abbr);
			const energyQuantity = energy.getQuantity(energyUnit);
			const energyAmount = energyQuantity.getFormAmount();

			this.setEnergyValue(energyAmount);
		}).catch(error => {
			console.log(error);
		});
	}

	setEnergyValue(value)
	{
		this.el.querySelector(`${BDiaryNutrientGoalTemplateForm.selector()} [name="nutrientAmount_ENERGY"]`).value = value;

		return this;
	}

	setIsCustom(isCustom)
	{
		this.el.querySelectorAll(`.diary-nutrient-goal-template-table__custom`).forEach(el => {
			el.hidden = !isCustom;
		});
	}
}
